import React from 'react'
import { useRandomId } from '@fs/zion-frontend-friends'

export default function FaceFeature({ scaleX, scale, fill, spacing, rotation, gradient, verticalOffset }) {
  const randomGradientId1 = `_${useRandomId()}`
  const randomGradientId2 = `_${useRandomId()}`

  const leftTransformOrigin = '8.28 4.6786'
  const rightTransformOrigin = '37.535 4.6786'

  return (
    <g transform={`scale(${scaleX},1) translate(0,${verticalOffset})`}>
      <g
        transform={`translate(${-spacing}) rotate(${rotation}) scale(${scale},${scale})`}
        transform-origin={leftTransformOrigin}
      >
        <path
          d="M0.350189 8.52869L16.9202 7.86865L16.3802 2.91858L0.180176 3.73865L0.350189 8.52869Z"
          fill={`url(#${randomGradientId1})`}
        />
        <path d="M0.179993 4.67859L16.56 4.01868L16.03 0.388672L0 1.20862L0.179993 4.67859Z" fill={fill} />
      </g>
      <g
        transform={`translate(${spacing}) rotate(${-rotation}) scale(${scale},${scale})`}
        transform-origin={rightTransformOrigin}
      >
        <path
          d="M45.4601 8.52869L28.8501 7.86865L29.3901 2.91858L45.6401 3.73865L45.4601 8.52869Z"
          fill={`url(#${randomGradientId2})`}
        />
        <path d="M45.64 4.67859L29.25 4.01868L29.79 0.388672L45.82 1.20862L45.64 4.67859Z" fill={fill} />
      </g>
      <defs>
        <linearGradient
          id={randomGradientId1}
          x1="8.55027"
          y1="9.49888"
          x2="8.55027"
          y2="4.40077"
          gradientUnits="userSpaceOnUse"
        >
          <stop offset="0.2877" stopColor={gradient[1]} stopOpacity="0" />
          <stop offset="0.8775" stopColor={gradient[0]} />
        </linearGradient>
        <linearGradient
          id={randomGradientId2}
          x1="37.2452"
          y1="9.49888"
          x2="37.2452"
          y2="4.40077"
          gradientUnits="userSpaceOnUse"
        >
          <stop offset="0.2877" stopColor={gradient[1]} stopOpacity="0" />
          <stop offset="0.8775" stopColor={gradient[0]} />
        </linearGradient>
      </defs>
    </g>
  )
}
